export const UserTypes = {
    GUEST: "Guest",
    ADMINISTRATOR: "Administrator",
    CSLT: "CSLT",
    CA: "CA",
    UBND: "UBND",
    THUE: "THUE"
}